import { render } from "./TitleTemplate.vue?vue&type=template&id=70be36c9&scoped=true&ts=true&lang=pug"
import script from "./TitleTemplate.vue?vue&type=script&lang=ts"
export * from "./TitleTemplate.vue?vue&type=script&lang=ts"

import "./TitleTemplate.vue?vue&type=style&index=0&id=70be36c9&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70be36c9"]])

export default __exports__